import { graphql } from '@/shared/graphql/generated'

/**
 * Die Dokumente der Bezahlschranke. Sie stehen hier und nicht beim Inhalt, weil der
 * Bezahlstatus dem Zahlungs-Feature gehoert - `ArticleOverview` holt sich `SET_USER_PAID`
 * deshalb ueber `@/features/payments` statt ueber den eigenen Ordner.
 */

export const GET_USER_PAID_STATUS = graphql(`
  query GetUserPaidStatus($userId: uuid!) {
    user_profiles(where: { user_id: { _eq: $userId } }, limit: 1) {
      id
      paid
    }
  }
`)

export const SET_USER_PAID = graphql(`
  mutation SetUserPaid($userId: uuid!) {
    insert_user_profiles_one(
      object: { user_id: $userId, paid: true }
      on_conflict: { constraint: user_profiles_user_id_key, update_columns: [paid] }
    ) {
      id
      paid
    }
  }
`)
